import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Skeleton, Box } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";

export function FilePreview({ file, videoPlaceHolder, imgPlaceHolder }) {
  const [loading, setLoading] = useState(true);

  const src =
    file.type === "video" ? file.poster || videoPlaceHolder : file.src;

  const alt = file.type === "video" ? "Video thumbnail" : file.alt || "Image";

  return (
    <Box sx={{ position: "relative", width: "100%", height: 180 }}>
      {/* Skeleton with overlay icon */}
      {loading && (
        <Box sx={{ position: "relative", width: "100%", height: 180 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={180}
            animation="wave"
            sx={{ borderRadius: 2 }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "rgba(0,0,0,0.4)",
              pointerEvents: "none",
            }}
          >
            <ImageIcon sx={{ fontSize: 40 }} />
          </Box>
        </Box>
      )}

      <LazyLoadImage
        src={src}
        alt={alt}
        effect="blur"
        height={180}
        width="100%"
        style={{
          objectFit: "cover",
          display: "block",
        }}
        beforeLoad={() => setLoading(true)}
        onLoad={() => setLoading(false)}
        onError={(e) => {
          setLoading(false);
          e.target.onerror = null;
          e.target.src = imgPlaceHolder;
        }}
      />
    </Box>
  );
}
